import {getStorage} from "@/utils/storage";
import {sharedServicesMgr} from "@/shared-services";
import { userPermissionsConfig$ } from "@/shared-services";
import {map, BehaviorSubject, Subject} from "rxjs";
import store from '@/store'
import { generateRoutes } from '@/router-v2/permission'
import {initPush, mergedEvent$} from "@/services/push";
import { createLoadCustomerFnApi } from "./subscribe-fleet-api/load";
import {getDriverGPSServerInstance} from "@/data-services/driver-gps-service";
import notification from "@/components/notification";
import {meInitializedStatus$} from "@/data-services/subjects";
import zendeskShow from "@/utils/zendesk";
import EVENT from "@/events";

class CommandTools {
  constructor(rootVue) {
    this.rootVue = rootVue
    this.$store = rootVue.$store 
    this.$fleetShowDialog = new Subject()
    this.$reloadScheduleDriverList = new Subject()
    this.$subscribeComponents = new Subject()
    this.$subscribeFleetApi = new Subject()
    this.driverGPSServer = getDriverGPSServerInstance()
    this.$dspClickEvent = new Subject()
    this.$eldRefreshButtonClick = new Subject()
    this.meInitializedStatus$ = meInitializedStatus$
    this.$weatherDetailsChangeFlag = new Subject()
    this.zendeskShow = zendeskShow;
    this.EVENT = EVENT
    if(!getStorage()) {
      this.meInitializedStatus$.next(true)
    }
  }
  getToken() {
    return getStorage()
  }
  $on(...args) {
    this.rootVue.$on(...args)
  }
  $off(...args) {
    this.rootVue.$off(...args)
  }
  $emit(...args) {
    this.rootVue.$emit(...args)
  }
  getHeaders() {
    if (getStorage('x-portal-token') === 'yes') {
      return { 'x-portal-token': getStorage() }
    } else {
      return { 'portal-token': getStorage() }
    }
  }
  getState() {
    return this.$store.state
  }
  // pls use $.complete() to unwatch.
  watch$(fun) {
    const $ = new BehaviorSubject(null)
    const unwatch = this.$store.watch(fun, value => $.next(value), {deep: true, immediate: true});
    $.subscribe({
      complete: unwatch
    })
    return $
  }
  get mergedEvent$() {
    return mergedEvent$
  }
  initPush(config) {
    initPush(config)
  }
  zendeskShow() {
    this._rootVue.$zendeskShow()
  }
  dspShowFleetDialogFn(show) {
    console.log(show,'60reuslt')
    this.$fleetShowDialog.next(show)
  }
  dspSubscribeComponentsFn(el) {
    this.$subscribeComponents.next(el)
  }
  subscribeFleetApiFn(type, data) {
    return createLoadCustomerFnApi()[type](data)
  }
  messageNotification(options, domNode) {
    notification(options, domNode)
  }
  commandCreateOrderBaseData() {
    let orderSource = "";
    const accountSubType = this.$store.state.user.accountSubType;
    switch (accountSubType) {
      case 'new_user':
      case 'free_user':
        orderSource = 'reactive_trial'
        break;
      case 'diamond_user':
        orderSource = 'diamond_first_order'
        break;
    }
    return {
      orderSource,
      commodity: null,
      orderInfo: null,
      userInfo: {
        email: this.$store.state.user.email,
      }
    }
  }
}

let instance = null

export function commandToolsInit($bus) {
  instance = new CommandTools($bus)

  userPermissionsConfig$.pipe(map(x => {
    x.$handler.subscribe(async(x)=> {
      if(x.isSave) {
        await store.dispatch("user/getUsersAuthoritiesF");
        generateRoutes();
      }
    })
  })).subscribe()
  sharedServicesMgr.register('CommandTools', () => instance)
}

export const getCommandTools = () => instance

